import * as constants from './constants.js'

export const inputRulers = [
  {
    label: '包含', //
    value: constants.INPUT.INCLUDE
  },
  {
    label: '不包含', //
    value: constants.INPUT.NOT_INCLUDE
  },
  {
    label: '等于', //
    value: constants.INPUT.EQUAL
  },
  {
    label: '不等于', //
    value: constants.INPUT.NOT_EQUAL
  },
  {
    label: '为空', //
    value: constants.COMMON.EMPTY
  },
  {
    label: '不为空', //
    value: constants.COMMON.NOT_EMPTY
  }
]

export const selectRulers = [
  {
    label: '选中', //
    value: constants.SELECT.SELECTED
  },
  {
    label: '未选中', //
    value: constants.SELECT.NOT_SELECTED
  },
  {
    label: '为空', //
    value: constants.COMMON.EMPTY
  },
  {
    label: '不为空', //
    value: constants.COMMON.NOT_EMPTY
  }
]

export const multiSelectRulers = [
  {
    label: '包含', //
    value: constants.MULTI_SELECT.INCLUDE
  },
  {
    label: '不包含', //
    value: constants.MULTI_SELECT.NOT_INCLUDE
  },
  {
    label: '只选中', //
    value: constants.MULTI_SELECT.SELECTED
  },
  {
    label: '未选中', //
    value: constants.MULTI_SELECT.NOT_SELECTED
  },
  {
    label: '为空', //
    value: constants.COMMON.EMPTY
  },
  {
    label: '不为空', //
    value: constants.COMMON.NOT_EMPTY
  }
]

export const cascaderRulers = [
  {
    label: '选中', //
    value: constants.CASCADER.SELECTED
  },
  {
    label: '未选中', //
    value: constants.CASCADER.NOT_SELECTED
  },
  {
    label: '为空', //
    value: constants.COMMON.EMPTY
  },
  {
    label: '不为空', //
    value: constants.COMMON.NOT_EMPTY
  }
]

export const numberRulers = [
  {
    label: '等于', //
    value: constants.NUMBER.EQUAL
  },
  {
    label: '不等于', //
    value: constants.NUMBER.NOT_EQUAL
  },
  {
    label: '大于', //
    value: constants.NUMBER.GREATER
  },
  {
    label: '大于或等于', //
    value: constants.NUMBER.GREATER_OR_EQUAL
  },
  {
    label: '小于', //
    value: constants.NUMBER.LESS
  },
  {
    label: '小于或等于', //
    value: constants.NUMBER.LESS_OR_EQUAL
  },
  {
    label: '介于（含等于）', //
    value: constants.NUMBER.BETWEEN
  },
  {
    label: '不介于', //
    value: constants.NUMBER.NOT_BETWEEN
  },
  {
    label: '为空', //
    value: constants.COMMON.EMPTY
  },
  {
    label: '不为空', //
    value: constants.COMMON.NOT_EMPTY
  }
]

export const dateRulers = [
  {
    label: '等于', //
    value: constants.DATE.EQUAL
  },
  {
    label: '不等于', //
    value: constants.DATE.NOT_EQUAL
  },
  {
    label: '早于', //
    value: constants.DATE.BEFORE
  },
  {
    label: '早于或等于', //
    value: constants.DATE.BEFORE_OR_EQUAL
  },
  {
    label: '晚于', //
    value: constants.DATE.AFTER
  },
  {
    label: '晚于或等于', //
    value: constants.DATE.AFTER_OR_EQUAL
  },
  {
    label: '介于（含等于）', //
    value: constants.DATE.BETWEEN
  },
  {
    label: '不介于', //
    value: constants.DATE.NOT_BETWEEN
  },
  {
    label: '为空', //
    value: constants.COMMON.EMPTY
  },
  {
    label: '不为空', //
    value: constants.COMMON.NOT_EMPTY
  }
]

export const labelRulers = selectRulers

// 地址类型
export const addressTypes = [
  {
    label: '省份', //
    value: constants.ADDRESS_TYPES.PROVINCE
  },
  {
    label: '城市', //
    value: constants.ADDRESS_TYPES.CITY
  },
  {
    label: '区/县', //
    value: constants.ADDRESS_TYPES.COUNTY
  },
  {
    label: '详细地址', //
    value: constants.ADDRESS_TYPES.DETAILED_ADDRESS
  }
]

export { constants }
